import { group } from 'd3';
import { useMemo } from 'react';
import CartesianGrid from '../../primitives/container/CartesianGrid';
import Plot from '../../primitives/container/Plot';
import Group from '../../primitives/shape/Group';
import { useSafeAccessors } from '../../primitives/shape/utils/accessors';
import { DEFAULT_MARGIN } from '../common/constants/constants';
import { LineAxes } from './elements/axis';
import { DataTable as LineDataTable } from './elements/data-table';
import { LineGrid } from './elements/grid';
import { LineLegend } from './elements/legend';
import { LineMarkSlot } from './elements/mark';
import { LineTooltip } from './elements/tooltip';
import { LineTooltipOverlay } from './elements/tooltip-overlay';
import { LineDataProvider } from './providers/data';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function defaultColorAccessor() {
  return d => '';
}
function useAccessors(_ref) {
  let {
    xAccessor,
    yAccessor,
    colorAccessor
  } = _ref;
  // GENERATE ENCODINGS
  const [x, y, color] = useMemo(() => {
    const [x] = useSafeAccessors(xAccessor);
    const [y] = useSafeAccessors(yAccessor);
    const [color] = useSafeAccessors(colorAccessor);
    return [x, y, color];
  }, [xAccessor, yAccessor, colorAccessor]);
  return {
    x,
    y,
    color
  };
}

/* 
Pure Line chart component.
*/
export function PureLineChart(_ref2) {
  let {
    data,
    width,
    height,
    xAccessor,
    yAccessor,
    colorAccessor,
    margin = DEFAULT_MARGIN,
    svgRef
  } = _ref2;
  const [plotHeight, plotWidth] = useMemo(() => [Math.max(0, height - margin.top - margin.bottom), Math.max(0, width - margin.left - margin.right)], [height, margin, width]);

  // GENERATE ACCESSORS
  const {
    x,
    y,
    color
  } = useAccessors({
    xAccessor,
    yAccessor,
    colorAccessor: colorAccessor || defaultColorAccessor()
  });
  const groups = useMemo(() => group(data, color), [data, color]);
  return /*#__PURE__*/_jsxs(LineDataProvider, {
    data: data,
    x: x,
    y: y,
    color: color,
    width: plotWidth,
    height: plotHeight,
    xAccessor: x,
    yAccessor: y,
    colorAccessor: color,
    margin: margin,
    lineGroups: groups,
    children: [colorAccessor && /*#__PURE__*/_jsx(LineLegend, {}), /*#__PURE__*/_jsxs(CartesianGrid, {
      children: [/*#__PURE__*/_jsx(LineGrid, {}), /*#__PURE__*/_jsx(LineAxes, {}), /*#__PURE__*/_jsx(Plot, {
        innerRef: svgRef,
        children: /*#__PURE__*/_jsxs(Group, {
          top: margin.top,
          left: margin.left,
          children: [/*#__PURE__*/_jsx(LineMarkSlot, {}), /*#__PURE__*/_jsx(LineTooltipOverlay, {})]
        })
      })]
    }), /*#__PURE__*/_jsx(LineTooltip, {}), /*#__PURE__*/_jsx(LineDataTable, {})]
  });
}